import { useMutation } from '@tanstack/react-query'
import { updateBankAccount } from '~/services/financial'
import { financialKeys } from '~/services/financial/keys'
import { UpdateBankAccountParams } from '~/services/financial/interface'

// Owner: processed immediately (status: 'EXECUTED'). Anyone else: goes to
// Owner-approval instead (status: 'PENDING') — the caller renders either from
// the resolved data, and a snackbar on error.
const useUpdateBankAccount = () => {
  return useMutation({
    mutationKey: financialKeys.bankAccountUpdate(),
    mutationFn: async (params: UpdateBankAccountParams) => {
      return await updateBankAccount(params)
    },
    retry: false,
  })
}

export default useUpdateBankAccount
